import { INote } from './NoteTypes';


export enum AccountTypes {
    MANAGER = 'Manager',
    COMPANY = 'Company',
    NEATT = 'Neatt',
    MEMBER = 'Member',
    CLIENT = 'Client',
    REFERRAL = 'Referrals',
    OWNER = 'Owner'
};
export interface NEATTData {
    fk: Record<any, any>;
    ei: Record<any, any>;
    lt: Record<any, any>;
    fh: Record<any, any>;
    fg: Record<any, any>;
    intakeBooked: boolean;
}

export interface BaseUserInfo {
    name: string;
    gender: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    phone: string;
    email: string;
    dob: string;
}


export interface BaseMetadata {
    createdAt: Date;
    cus_id: string;
    updatedAt: Date;
    firstLogin: boolean;
    stripeId: string;
    agreedToTerms: boolean;
    invitedBy?: string;
    groups?: string[];  // Cognito groups from backend
    permissions?: {     // Computed permissions from backend
        canAccessAdmin?: boolean;
        canAccessPartnerDashboard?: boolean;
        canAccessClientDashboard?: boolean;
    };
}
export interface User<TUserInfo = BaseUserInfo> {
    userId: string;
    userType: AccountTypes;
    userInfo: TUserInfo;
    metadata: BaseMetadata;
}


export interface ClientUserInfo extends BaseUserInfo {
    companyId: string;
    memberId: string;
}

export interface ClientMetadata extends BaseMetadata {
    approvedBy?: string;
}

export interface ConsultantUserInfo
    extends Omit<BaseUserInfo, "city" | "address" | "state" | "zip" | "dob" | "gender"> {
    source: string;
}

export interface ManagerUserInfo
    extends Omit<BaseUserInfo, "city" | "address" | "state" | "zip" | "dob" | "gender"> {
}

export interface ReferralPartnerUserInfo extends Omit<BaseUserInfo, "name" | "dob" | "gender"> {
    companyName: string;
    representativeName: string;
    websiteURL: string;
}

export interface SubscriberUserInfo extends Omit<BaseUserInfo, "dob" | "gender"> {
    reasonForSubscription: string;
    referredBy?: string;
}

export interface ReferralPartnerMetadata extends BaseMetadata {
      reasonForPartnership: string;
      sourceOfClients: string;
      clientsPerMonth: string;
      howDidYouHear: string;
      expectations: string;
      references: string;
      referralCount: number;
}

export interface SubscriberMetadata extends BaseMetadata {
    active: boolean;
}

export interface Client extends User<ClientUserInfo> {
    userType: AccountTypes.CLIENT;
    metadata: ClientMetadata;
    neatt?: NEATTData;
    notes?: INote[];
    leadAssigned?: {
        name: string;
        id: string;
    };
}

export interface ReferralPartner extends User<ReferralPartnerUserInfo> {
    userType: AccountTypes.REFERRAL;
    metadata: ReferralPartnerMetadata;
}

export interface Subscriber extends User<SubscriberUserInfo> {
    userType: AccountTypes.COMPANY;
    metadata: SubscriberMetadata;
}

export interface Consultant extends User<ConsultantUserInfo> {
  userType: AccountTypes.NEATT;
  metadata: BaseMetadata;
}

export interface Manager extends User<ManagerUserInfo> {
    userType: AccountTypes.MANAGER
}

export interface Owner extends User {
    userType: AccountTypes.OWNER
}
